/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AccountType, FeedType, PackageReference } from "@octopusdeploy/octopus-server-client";
import { exhaustiveCheck } from "@octopusdeploy/type-utils";
import React from "react";
import type { ProcessTemplateActionInputsDependencies } from "~/components/ActionInputs/ProcessTemplateActionInputs";
import { ProcessTemplateActionInputs } from "~/components/ActionInputs/ProcessTemplateActionInputs";
import type { ProjectActionInputsDependencies } from "~/components/ActionInputs/ProjectActionInputs";
import { ProjectActionInputs } from "~/components/ActionInputs/ProjectActionInputs";
import type { CombinedVolumeDetails } from "~/components/Actions/kubernetes/kubernetesDeployContainersAction";
import type { ActionTemplateActionInputsDependencies } from "./ActionTemplateActionInputs";
import { ActionTemplateActionInputs } from "./ActionTemplateActionInputs";
type ActionInputElement = {
    type: "docker-reference-list-form";
    key: string;
    hasModelDirty?: boolean;
    hasRelatedTriggersDependencies?: boolean;
    hideAcquisitionChoices: boolean;
} | {
    type: "container-image-reference-list";
    key: string;
    hasModelDirty?: boolean;
    hasRelatedTriggersDependencies?: boolean;
    hideAcquisitionChoices: boolean;
} | {
    type: "deferred-package-selector";
    key: string;
    feedType?: FeedTypeOrFactory;
    hasModelDirty?: boolean;
    hasRelatedTriggersDependencies?: boolean;
} | {
    type: "package-selector";
    key: string;
    feedType?: FeedTypeOrFactory;
    hasModelDirty?: boolean;
    hasRelatedTriggersDependencies?: boolean;
} | {
    type: "azure-account-selector";
    key: string;
    accountType: AccountType[];
    clearLegacyProps?: () => void;
} | {
    type: "sensitive-value-selector";
    key: string;
    propertyKey: string;
    label?: string;
    helperText?: React.ReactNode;
} | {
    type: "container-list-section";
    key: string;
    volumes: CombinedVolumeDetails[];
};
export type FeedTypeOrFactory = FeedType[] | ((actionInputsDependencies: ActionInputsDependencies) => FeedType[]);
export type ActionInputDefinition = ActionInputElement[];
interface ActionInputsProps {
    actionUIDefinition: ActionInputDefinition;
    dependencies: ActionInputsDependencies;
}
export interface InitialInputsBuilder {
    initializePackages: () => PackageReference<any>[];
}
export type ActionInputsDependencies = ProjectActionInputsDependencies | ProcessTemplateActionInputsDependencies | ActionTemplateActionInputsDependencies;
export function ActionInputs({ actionUIDefinition, dependencies }: ActionInputsProps) {
    const type = dependencies.type;
    switch (type) {
        case "project":
            return <ProjectActionInputs actionUIDefinition={actionUIDefinition} dependencies={dependencies}/>;
        case "action-template":
            return <ActionTemplateActionInputs actionUIDefinition={actionUIDefinition} dependencies={dependencies}/>;
        case "process-template":
            return <ProcessTemplateActionInputs actionUIDefinition={actionUIDefinition} dependencies={dependencies}/>;
        default:
            exhaustiveCheck(type, "Unknown action inputs dependencies type");
    }
}
